export const APAC_UI_NAME = "apac-ui";

export enum ApacUiComponent {
  TravelerCards = "TravelerCards",
  PriceDotIndicator = "PriceDotIndicator",
  AmenitiesDialog = "AmenitiesDialog",
  LocationAutoCompleteWithSuggestion = "LocationAutoCompleteWithSuggestion",
  NumberSelector = "NumberSelector",
  NumberPickerDialog = "NumberPickerDialog",
  SwitchWithText = "SwitchWithText",
  BestPriceGuaranteeLink = "BestPriceGuaranteeLink",
  BestPriceGuaranteeModalContent = "BestPriceGuaranteeModalContent",
  BestPriceGuaranteeCard = "BestPriceGuaranteeCard",
  NoticeBanner = "NoticeBanner",
}
